class MochiDeviceLanding extends HTMLElement {
  connectedCallback() {
    this.deviceButtons = [...this.querySelectorAll('[data-device-choice]')];
    this.rangeButtons = [...this.querySelectorAll('[data-range-choice]')];
    this.backButtons = [...this.querySelectorAll('[data-device-back]')];
    this.devicePanel = this.querySelector('[data-device-panel]');
    this.iphonePanel = this.querySelector('[data-iphone-panel]');
    this.catalogPanels = [...this.querySelectorAll('[data-catalog-panel]')];

    this.deviceButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectDevice(button.dataset.deviceChoice));
    });
    this.rangeButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectRange(button.dataset.rangeChoice));
    });
    this.backButtons.forEach((button) => {
      button.addEventListener('click', () => this.resetFlow());
    });

    const route = window.location.hash.replace('#', '');
    if (route === 'samsung') this.selectDevice('samsung', false);
    if (route === 'iphone') this.selectDevice('iphone', false);
    if (route === 'iphone-guidee') {
      this.selectDevice('iphone', false);
      this.selectRange('guided', false);
    }
    if (route === 'iphone-manuelle') {
      this.selectDevice('iphone', false);
      this.selectRange('iphone-manual', false);
    }
  }

  selectDevice(device, shouldScroll = true) {
    this.deviceButtons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.deviceChoice === device ? 'true' : 'false');
    });
    this.iphonePanel.hidden = device !== 'iphone';
    this.catalogPanels.forEach((panel) => {
      panel.hidden = panel.dataset.catalogPanel !== 'samsung' || device !== 'samsung';
    });
    this.rangeButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
    this.classList.add('mdl--selected');
    window.history.replaceState(null, '', `#${device}`);

    const target = device === 'iphone' ? this.iphonePanel : this.querySelector('[data-catalog-panel="samsung"]');
    this.hydratePanel(target);
    if (shouldScroll) this.scrollToPanel(target);
  }

  selectRange(range, shouldScroll = true) {
    this.rangeButtons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.rangeChoice === range ? 'true' : 'false');
    });
    this.catalogPanels.forEach((panel) => {
      panel.hidden = panel.dataset.catalogPanel !== range;
    });
    const hash = range === 'guided' ? 'iphone-guidee' : 'iphone-manuelle';
    window.history.replaceState(null, '', `#${hash}`);
    const target = this.querySelector(`[data-catalog-panel="${range}"]`);
    this.hydratePanel(target);
    if (shouldScroll) this.scrollToPanel(target);
  }

  resetFlow() {
    this.deviceButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
    this.rangeButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
    this.iphonePanel.hidden = true;
    this.catalogPanels.forEach((panel) => { panel.hidden = true; });
    this.classList.remove('mdl--selected');
    window.history.replaceState(null, '', window.location.pathname);
    this.scrollToPanel(this.devicePanel);
  }

  scrollToPanel(target) {
    if (!target) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(() => target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' }));
  }

  hydratePanel(panel) {
    if (!panel) return;
    panel.querySelectorAll('img[data-mochi-src]').forEach((image) => {
      if (image.dataset.mochiSrcset) image.srcset = image.dataset.mochiSrcset;
      image.src = image.dataset.mochiSrc;
      image.removeAttribute('data-mochi-src');
      image.removeAttribute('data-mochi-srcset');
    });
  }
}

if (!customElements.get('mochi-device-landing')) {
  customElements.define('mochi-device-landing', MochiDeviceLanding);
}
